<template>
  <a-card>
    <div style="text-align: right;">
      <span
        class="ant-descriptions-title"
        style="float: left; margin-top: 5px;"
      >
        <a-icon type="tags" /> Type Leave
      </span>
      <a-input
        placeholder="Search..."
        style="width: 350px; max-width: 100%; margin-right: 5px;"
        @change="onFilter"
        v-model="filter.query"
      />
      <a-select
        placeholder="Select benefit"
        style="width: 250px; margin-right: 5px;"
        allowClear
        v-model="filter.benefit"
        @change="onFilter"
      >
        <a-select-option v-for="i in typeBenefits" :key="i.id">
          {{ i.title }}
        </a-select-option>
      </a-select>
      <a-button slot="extra" type="primary" @click="() => (visibleAdd = true)">
        <a-icon type="plus" /> Add New
      </a-button>
    </div>

    <a-table
      :columns="columnsAllTypeWorkLeave"
      :data-source="typeWorkLeaves"
      size="small"
      :loading="loadingList"
      rowKey="id"
      :pagination="{
        current: currentPage,
        onChange: (page) => {
          this.currentPage = page;
        },
        pageSize: limit,
      }"
    >
      <div slot="footer">
        <a-button
          :loading="loadingList"
          type="link"
          @click="onPagination"
          :disabled="!isPagination"
        >
          <a-icon type="reload" /> Tải thêm
        </a-button>
      </div>
      <a
        slot="titleType"
        slot-scope="text, record"
        @click="collapseVisibleEdit(record.id)"
      >
        {{ text }}
      </a>
      <a
        slot="code"
        slot-scope="text, record"
        @click="collapseVisibleEdit(record.id)"
      >
        {{ text }}
      </a>
      <span slot="benefit" slot-scope="text">
        {{ codeBenefit2Title(text) }}
      </span>
      <span slot="author" slot-scope="text">
        {{ text.author && (text.author.fullname || text.author.username) }}
      </span>
      <span slot="createdAt" slot-scope="text">
        {{ text | formatDateHour }}
      </span>
      <span slot="updatedAt" slot-scope="text">
        {{ text | formatDateHour }}
      </span>
      <span slot="action" style="float: right;" slot-scope="text, record">
        <a-button @click="collapseVisibleEdit(record.id)">
          <a-icon title="Chỉnh sửa" type="edit" /> Edit
        </a-button>
      </span>
    </a-table>

    <a-drawer
      v-if="visibleEdit"
      title="Edit"
      placement="right"
      :visible="visibleEdit"
      @close="() => (visibleEdit = false)"
      :width="450"
      :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
    >
      <EditTypeWorkLeave
        :idTypeWorkLeave="idTypeWorkLeave"
        :close="() => (visibleEdit = false)"
        :refreshAfterUpdated="refreshAfterUpdated"
        :refreshAfterDeleted="refreshAfterDeleted"
      />
    </a-drawer>

    <a-drawer
      v-if="visibleAdd"
      title="Add New"
      placement="right"
      :visible="visibleAdd"
      @close="() => (visibleAdd = false)"
      :width="450"
      :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
    >
      <AddTypeWorkLeave
        :close="() => (visibleAdd = false)"
        :refreshAfterCreated="refreshAfterCreated"
      />
    </a-drawer>
  </a-card>
</template>
<script>
import { columnsAllTypeWorkLeave } from "./constant/column";
import AddTypeWorkLeave from "./components/addTypeWorkLeave";
import DetailTypeWorkLeave from "./components/detailTypeWorkLeave";
import EditTypeWorkLeave from "./components/editTypeWorkLeave";
import query from "./constant/query";
import {
  updateForCreated,
  updateForUpdated,
  updateForDeleted,
} from "@/services/updateOnViewConfig";
import codeBenefit2Title from "./services/codeBenefit2Title";
import debounce from "lodash/debounce";
import { typeBenefits } from "./constant/default";

const limit = 10;
const startPage = 1;
const defaultFilter = { query: undefined, benefit: undefined };

export default {
  components: { AddTypeWorkLeave, EditTypeWorkLeave },
  data() {
    this.onFilter = debounce(this.onFilter, 500);
    return {
      typeBenefits,
      limit,
      visibleEdit: false,
      visibleDetail: false,
      visibleAdd: false,
      columnsAllTypeWorkLeave,
      loadingList: true,
      typeWorkLeaves: [],
      roots: [],
      idTypeWorkLeave: "",
      filter: { ...defaultFilter },
      currentPage: startPage,
      isPagination: true,
    };
  },
  methods: {
    codeBenefit2Title,
    onGetAllTypeWorkLeave(flag) {
      this.loadingList = true;
      this.$apollo
        .query({
          query: query.getAllTypeWorkLeave,
          fetchPolicy: "no-cache",
          variables: {
            query: this.filter.query,
            limit,
            page: this.currentPage,
            benefit: this.filter.benefit,
          },
        })
        .then(({ data }) => {
          this.loadingList = false;
          if (data?.getAllTypeWorkLeave?.length >= 0) {
            if (flag === "FILTER") {
              this.typeWorkLeaves = [...data.getAllTypeWorkLeave];
            } else if (flag === "PAGINATION") {
              this.typeWorkLeaves = this.typeWorkLeaves.concat([
                ...data.getAllTypeWorkLeave,
              ]);
            } else {
              this.typeWorkLeaves = [...data.getAllTypeWorkLeave];
            }

            // check is pagniation
            if (data.getAllTypeWorkLeave.length < limit) {
              this.isPagination = false;
            } else {
              this.isPagination = true;
            }
          }
        })
        .catch((err) => {
          this.loadingList = false;
          this.$notification.error({
            message: "Error",
            description: "Updated Error!",
          });
          console.log("Lấy danh sách loại nghỉ phép không thành công", err);
        });
    },
    collapseVisibleDetail(id) {
      if (id) {
        this.idTypeWorkLeave = id;
        this.visibleDetail = true;
      } else {
        this.idTypeWorkLeave = "";
        this.visibleDetail = false;
      }
    },
    collapseVisibleEdit(id) {
      if (id) {
        this.idTypeWorkLeave = id;
        this.visibleEdit = true;
      } else {
        this.idTypeWorkLeave = "";
        this.visibleEdit = false;
      }
    },
    onFilter(e) {
      this.currentPage = startPage;
      this.onGetAllTypeWorkLeave("FILTER");
    },
    refreshAfterUpdated(item) {
      this.typeWorkLeaves = updateForUpdated(this.typeWorkLeaves, item);
      this.roots = updateForUpdated(this.roots, item);
    },
    refreshAfterDeleted(item) {
      this.typeWorkLeaves = updateForDeleted(this.typeWorkLeaves, item);
      this.roots = updateForDeleted(this.roots, item);
    },
    refreshAfterCreated(item) {
      this.typeWorkLeaves = updateForCreated({
        list: this.typeWorkLeaves,
        item,
      });
      this.roots = updateForCreated({ list: this.roots, item });
    },
    onPagination() {
      if (this.isPagination) {
        this.currentPage += 1;
        this.onGetAllTypeWorkLeave("PAGINATION");
      }
    },
  },
  created() {
    this.onGetAllTypeWorkLeave();
  },
};
</script>
<style lang="css" scoped></style>
